/* eslint-disable func-call-spacing */
/* eslint-disable no-restricted-imports */
import { DpDrawer } from '@/components/blocks/DpDrawer';
import { Linkable } from '@/components/blocks/Linkable';
import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { Skeleton, Stack } from '@mui/material';
import { useIsOpen } from 'integration/hooks/useIsOpen';
import { createContext, useContext } from 'react';

const DpDrawerHandlerContext = createContext<ReturnType<typeof useIsOpen>>({
	open: false,
	on: () => null,
	off: () => null,
	toggle: () => null,
});

const DpDrawerHandlerProvider = DpDrawerHandlerContext.Provider;

const useDpDrawerHandler = () => {
	const context = useContext(DpDrawerHandlerContext);

	if (!context) {
		throw new Error('useDpDrawerHandler must be used within a DpDrawerHandlerProvider');
	}

	return context;
};

interface DpDrawerHandlerProps {
	title: string;
	spot: string;
}

export const DpDrawerHandlerRecommendation: React.FC<DpDrawerHandlerProps> = ({ spot, title }) => {
	const { open, off } = useDpDrawerHandler();

	return (
		<DpDrawer title={title} open={open} onClose={off}>
			<ContentRecommendation
				id={spot}
				properties={{
					emsName: spot,
				}}
				loadingElement={
					<Stack>
						<Skeleton variant="rectangular" height={100} />
						<Skeleton variant="rectangular" height={100} />
						<Skeleton variant="rectangular" height={100} />
						<Skeleton variant="rectangular" height={100} />
						<Skeleton variant="rectangular" height={100} />
					</Stack>
				}
			/>
		</DpDrawer>
	);
};

export const DpDrawerHandlerOpen: React.FC<React.PropsWithChildren> = ({ children, ...props }) => {
	const { on } = useDpDrawerHandler();

	return (
		<Linkable href="" type="inline" variant="primary" {...props} onClick={on}>
			{children}
		</Linkable>
	);
};

export const DpDrawerHandler: React.FC<React.PropsWithChildren<DpDrawerHandlerProps>> = ({
	children,
	title,
	spot,
}) => {
	const openDrawer = useIsOpen();

	return (
		<DpDrawerHandlerProvider value={openDrawer}>
			{children}
			<DpDrawerHandlerRecommendation title={title} spot={spot} />
		</DpDrawerHandlerProvider>
	);
};
